/**
 * digital-hide-options.js
 *
 * 1. Blendet Abo-Art (Option 2) und Region & Zustellung (Option 3) aus,
 *    sobald Format (Option 1) auf "Digital" steht.
 * 2. Springt beim Klick auf "Digital" automatisch zu einer echten
 *    existierenden Digital-Variante (setzt Abo-Art/Region passend um),
 *    damit Preis und Badge korrekt erscheinen – exakt so, als hätte man
 *    manuell die passende Kombination gewählt. Das behebt das Problem
 *    an der Wurzel statt nur optisch nachzubessern.
 *
 * Sicherheit: Rein clientseitige UI-Steuerung, keine Bestelldaten werden
 * verändert. Nutzt nur bereits vorhandene, öffentlich zugängliche
 * Produktdaten (/products/handle.js).
 */

(function () {
  const DIGITAL_OPTION_WERT = 'Digital';
  const produktVariantenCache = {};

  function ausgewaehlterFormatWert(root) {
    const ersteOptionFieldset = root.querySelector('fieldset[data-option-position="1"]');
    if (ersteOptionFieldset) {
      const checkedRadio = ersteOptionFieldset.querySelector('input[type="radio"]:checked');
      if (checkedRadio) return checkedRadio.value;
    }
    return null;
  }

  function feldFuerFormatVerstecken(root) {
    const istDigital = ausgewaehlterFormatWert(root) === DIGITAL_OPTION_WERT;
    root.querySelectorAll('fieldset[data-option-position="2"], fieldset[data-option-position="3"]').forEach(function (fieldset) {
      fieldset.style.display = istDigital ? 'none' : '';
    });
  }

  function alleRootsPruefen() {
    document.querySelectorAll('variant-selects').forEach(feldFuerFormatVerstecken);
  }

  /**
   * Lädt die Variantenliste des aktuellen Produkts einmalig
   * (via öffentlicher .js-Endpunkt, kein Adminzugriff nötig).
   */
  async function variantenLaden(handle) {
    if (produktVariantenCache[handle]) return produktVariantenCache[handle];
    try {
      const res = await fetch('/products/' + handle + '.js');
      const data = await res.json();
      produktVariantenCache[handle] = data.variants;
      return data.variants;
    } catch (e) {
      console.error('Variantendaten konnten nicht geladen werden:', e);
      return [];
    }
  }

  /**
   * Setzt einen Radio-Wert programmatisch und feuert 'change',
   * damit das Theme ganz normal darauf reagiert (Section-Re-Fetch etc.).
   */
  function radioSetzenUndAusloesen(fieldset, wert) {
    if (!fieldset) return;
    const ziel = fieldset.querySelector('input[type="radio"][value="' + CSS.escape(wert) + '"]');
    if (ziel && !ziel.checked) {
      ziel.checked = true;
      ziel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /**
   * Wenn "Digital" gewählt wird, aber die aktuelle Kombination aus
   * Abo-Art/Region keine echte Variante ergibt, automatisch auf die
   * nächstliegende echte Digital-Variante springen.
   */
  async function aufEchteDigitalVarianteSpringen(root) {
    const handle = window.location.pathname.split('/').pop();
    const varianten = await variantenLaden(handle);

    const digitalVarianten = varianten.filter(function (v) { return v.option1 === DIGITAL_OPTION_WERT; });
    if (digitalVarianten.length === 0) return;

    const zweiteFieldset = root.querySelector('fieldset[data-option-position="2"]');
    const dritteFieldset = root.querySelector('fieldset[data-option-position="3"]');
    const aktuellerWert2 = zweiteFieldset?.querySelector('input[type="radio"]:checked')?.value;
    const aktuellerWert3 = dritteFieldset?.querySelector('input[type="radio"]:checked')?.value;

    // Passende Digital-Variante suchen: erst exakte Übereinstimmung
    // von Abo-Art/Region versuchen, sonst einfach die erste nehmen.
    let zielVariante =
      digitalVarianten.find(function (v) { return v.option2 === aktuellerWert2 && v.option3 === aktuellerWert3; }) ||
      digitalVarianten.find(function (v) { return v.option2 === aktuellerWert2; }) ||
      digitalVarianten[0];

    if (zielVariante.option2 && zielVariante.option2 !== aktuellerWert2) {
      radioSetzenUndAusloesen(zweiteFieldset, zielVariante.option2);
    }
    if (zielVariante.option3 && zielVariante.option3 !== aktuellerWert3) {
      radioSetzenUndAusloesen(dritteFieldset, zielVariante.option3);
    }
  }

  function init() {
    alleRootsPruefen();

    document.querySelectorAll('variant-selects').forEach(function (root) {
      if (root.dataset.digitalSpringSetup === 'true') return;
      root.dataset.digitalSpringSetup = 'true';

      const ersteFieldset = root.querySelector('fieldset[data-option-position="1"]');
      if (ersteFieldset) {
        ersteFieldset.addEventListener('change', function (e) {
          if (e.target.value === DIGITAL_OPTION_WERT) {
            setTimeout(function () { aufEchteDigitalVarianteSpringen(root); }, 10);
          }
        });
      }
    });

    if (!window.__digitalHideOptionsIntervalGestartet) {
      window.__digitalHideOptionsIntervalGestartet = true;
      setInterval(alleRootsPruefen, 250);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof subscribe === 'function') {
    subscribe('variant-change', function () {
      setTimeout(init, 50);
    });
  }
})();